import { render, staticRenderFns } from "./uvip.vue?vue&type=template&id=0e5d3a72&scoped=true&"
import script from "./uvip.vue?vue&type=script&lang=js&"
export * from "./uvip.vue?vue&type=script&lang=js&"
import style0 from "./uvip.vue?vue&type=style&index=0&id=0e5d3a72&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e5d3a72",
  null
  
)

export default component.exports